import { createRoutine } from 'redux-saga-routines';

export const fetchROItems = createRoutine('FETCH_RO_ITEMS');

export const fetchROItemForEdit = createRoutine('FETCH_RO_ITEM_EDIT');

export const fetchROItemForView = createRoutine('FETCH_RO_ITEM_VIEW');

export const createROItem = createRoutine('CREATE_RO_ITEM');

export const updateROItem = createRoutine('UPDATE_RO_ITEM');

export const deleteROItem = createRoutine('DELETE_RO_ITEM');

export const fetchROItemAssocPicklistCount = createRoutine(
  'FETCH_RO_ITEM_ASSOC_PICKLIST_COUNT'
);
